// ===== ELITE BRAND - Scroll Reveal + Particles (v2) =====

document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.shopify-section');
  sections.forEach((s, i) => {
    // استثنِ أول قسم (الهيرو) والهيدر والفوتر - يظهروا فورًا بدون تأخير
    const idLower = (s.id || '').toLowerCase();
    if (i === 0 || idLower.includes('header') || idLower.includes('footer')) return;
    s.classList.add('elite-reveal');
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });

  document.querySelectorAll('.elite-reveal').forEach(s => observer.observe(s));
});

document.addEventListener('DOMContentLoaded', () => {
  // اختيار أدق للهيرو فقط - بدون substring matching واسع
  const hero = document.querySelector('.banner') || document.querySelector('.hero');
  if (!hero) return;
  hero.style.position = 'relative';

  const container = document.createElement('div');
  container.className = 'elite-particles';
  hero.appendChild(container);

  for (let i = 0; i < 18; i++) {
    const p = document.createElement('div');
    p.className = 'elite-particle';
    p.style.left = Math.random() * 100 + '%';
    p.style.bottom = Math.random() * 30 + '%';
    p.style.animationDelay = Math.random() * 6 + 's';
    p.style.animationDuration = (4 + Math.random() * 4) + 's';
    container.appendChild(p);
  }
});